module.exports = __webpack_public_path__ + "img/mastercard-securecode.e0e499d1.jpg";